import { BucketAwtENUM, gridSizeConst2, gridSizeMdLg12, useUploadFile } from "@/shared";
import { FileCopy, Delete } from "@mui/icons-material";
import { Button, Grid, IconButton, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import {useDropzone} from 'react-dropzone';
import { UseFormReturn } from "react-hook-form";
import { toast } from "react-toastify";

type Documentos = {
    name: string,
    url: string
}

type Props = {
    form: UseFormReturn<any, any, any>;
    bucket?: BucketAwtENUM;
    maxFiles?: number;
    restrictionType?: "image"| "pdf",
    placeholder?: string
    keyForm?: string
    showButtonNewDocuments?: boolean
    titleCargaAnexos?: string
    sizeItem?: any
    titleButtonSave?: string
}

const DropzoneFiles = ({
    form,
    bucket,
    maxFiles = 99,
    restrictionType,
    placeholder = "Cargue aquí los documentos necesarios",
    keyForm="documentos",
    showButtonNewDocuments = true,
    titleCargaAnexos = "Carga de Anexos para Preventa Corporativa",
    sizeItem,
    titleButtonSave = "Guardar Documentos de Preventa"
}: Props) => {

    const { handleUploadFile } = useUploadFile()

    const [enableNewDocuments, setEnableNewDocuments] = useState<boolean>(false);
    const [filesToUpload, setFilesToUpload] = useState<File[]>([]);

    const onDrop = useCallback((acceptedFiles:any) => {
        if ((filesToUpload.length + acceptedFiles.length) > maxFiles) {
            return toast.error("Máximo 5 archivos");
        }

        if (!!restrictionType) {
            const correctType = acceptedFiles.every((file:File) => file.type.includes(restrictionType));
            if (!correctType) {
                return toast.error("Uno o varios de los archivos no corresponde al tipo permitido.");
            }
        }

        console.log({ acceptedFiles });

        acceptedFiles.forEach((file: File) => {
            const reader = new FileReader();

            reader.onabort = () => console.log('file reading was aborted');
            reader.onerror = () => console.log('file reading has failed');
            reader.onload = () => {
            const binaryStr = reader.result;
                console.log(binaryStr);
            };
            reader.readAsArrayBuffer(file);
        });

        form.reset({
            ...form.getValues(),
            "documentos_guardados":false
        })
        setFilesToUpload(prev => [...prev, ...acceptedFiles]);
    }, [filesToUpload, maxFiles, restrictionType])

    const UploadFiles = async() => {
        const arrayFiles = [...form.getValues()?.pre_documentos]
        
        ///* Documentos pendientes por subir
        if (arrayFiles.some(e => e == null))
            return toast.error("Aún no se han cargado documentos.")

        try {
            // const resUploadFiles:ApiFileRespAWT[] = []
            // arrayFiles.forEach(async(item)=>{
            //     const res = await handleUploadFile(item, BucketAwtENUM.DOCUMENTOS_PREVENTA_CORPORATIVA)
            //     resUploadFiles.push(res)
            // })

            const respData = await Promise.all(
                arrayFiles.map((item)=>
                    handleUploadFile(item,bucket || BucketAwtENUM.DOCUMENTOS_PREVENTA_CORPORATIVA)
                )
            )
            // console.log({respData})


            const dataFormatForm:Documentos[] = respData.map((item)=>{
                return {
                    "name": item.id_archivos,
                    "url": item.url
                }
            })
            console.log({dataFormatForm})

            form.reset({
                ...form.getValues(),
                [keyForm||"documentos"]: dataFormatForm,
                "documentos_guardados":true
            })
            toast.success("Documentos guardados. A continuación guarde la preventa para aplicar los cambios",{
                autoClose:5000
            })
            setEnableNewDocuments(false)

        } catch (error) {
            return toast.error('Error al cargar los documentos')
        }

    }






    useEffect(() => {
        // console.log({"veamos":filesToUpload})
        if(filesToUpload.length>0){
            form.reset({
                ...form.getValues(),
                "pre_documentos": filesToUpload
            })
        }
    }, [filesToUpload]);
    useEffect(() => {
        
        if(filesToUpload.length == 0 
        && form.getValues()?.pre_documentos 
        && form.getValues()?.pre_documentos>0){
            onDrop(form.getValues()?.pre_documentos)
        }
        form.reset({
            ...form.getValues(),
            [keyForm]: form.getValues()?.[keyForm],
            "documentos_guardados":true
        })

    }, []);

    // useEffect(()=>{
    //     if(form.getValues()?.documentos){
    //         setDocPrevios(form.getValues().documentos)
    //     }
    // },[])

    // const onDeleteFile = (file:File) => {
    //     const withoutDeleted = filesToUpload.filter(x=>x.name !== file.name)
    //     setFilesToUpload(withoutDeleted)
    //     onDrop(withoutDeleted)
    // }
    const onDeleteFile = (fileToDelete: File) => {
        const withoutDeleted = form.getValues().pre_documentos.filter(
            (f:File) => !(f.name === fileToDelete.name && f.size === fileToDelete.size)
        );
        setFilesToUpload(withoutDeleted);
        form.reset({
            ...form.getValues(),
            "pre_documentos": withoutDeleted
        })
        toast.info("Archivo eliminado");
    };

    const {getRootProps, getInputProps} = useDropzone({onDrop})
    
    return (
        <Grid item spacing={2} rowSpacing={2} {...gridSizeMdLg12}>
            <Grid container marginY={1}>
                <Typography variant="h6" fontWeight={700}>{titleCargaAnexos}</Typography>
            </Grid>
            {
                form && form.getValues()?.[keyForm!] 
                && form.getValues()?.[keyForm!]?.length>0 && !enableNewDocuments?
                <Grid>
                    {
                        form.getValues()?.[keyForm!]?.map((item:Documentos, index:number)=>{
                            return(
                                <Typography key={"doc-prev-"+index} >
                                    <a href={`${item.url}?=${new Date()}`} target="_blank" >
                                        {`Enlace al archivo #${index+1}`} 
                                    </a>
                                </Typography>
                            )
                        })
                    }
                </Grid>
                :
                <>
                    <Grid container  {...gridSizeMdLg12} 
                        direction={"row"}
                        sx={{
                            border:"2px solid #ccc",
                            borderRadius:"5px",
                            transition:"background-color 0.3s ease-in-out",
                            // marginX:2,
                            padding:2,
                            textAlign:"center",
                            width:"100%",
                            '&:hover': {
                                backgroundColor: '#f1f1f1',
                                cursor:"pointer"
                            },
                        }}
                        {...getRootProps()}
                    >
                        <input {...getInputProps()} />
                        {
                            form && form.getValues()?.pre_documentos 
                            && form.getValues()?.pre_documentos.length >0 ?(
                                form.getValues()?.pre_documentos.map((item:File)=>{
                                    return <FileItemInDropZone itemFile={item} onDelete={onDeleteFile} sizeItem={sizeItem}/>
                                })
                            ):
                            <p>{placeholder}</p>

                        }
                    </Grid>
                </>
            }
            {showButtonNewDocuments && <Grid item {...gridSizeMdLg12} marginY={2}>
                {
                    form && form.getValues()?.documentos && !enableNewDocuments?
                    <Button variant="outlined" onClick={()=>setEnableNewDocuments(true)}>Borrar y Subir nuevos Documentos</Button>
                    :
                    <Button variant="contained" onClick={()=>UploadFiles()}>{titleButtonSave}</Button>
                }
            </Grid>}
        </Grid>
    )
}

export default DropzoneFiles

const FileItemInDropZone = ({
    itemFile,
    onDelete,
    sizeItem = gridSizeConst2
}:{
    itemFile:File,
    onDelete?:(file:File)=>void,
    sizeItem:any
}) => {
    return (
        <Grid item {...sizeItem} 
            sx={{padding:1, justifyContent:"center",
                zIndex:10, position:"relative"
            }}>
            <div onClick={e=>e.stopPropagation()} style={{ gridColumn: "span 2", 
                border:"2px solid #ccc", overflow:"hidden",
                padding:5, borderRadius:5 }}>
                <FileCopy sx={{fontSize: 50, color:"#ccc"}}/>
                <Grid item>
                    <Typography variant="caption">{itemFile.name||"Documento Cargado"}</Typography>
                </Grid>
                {
                    onDelete &&
                    <IconButton sx={{position:"absolute", top:15, right:10, zIndex:100}}
                    onClick={()=>onDelete(itemFile)}>
                        <Delete sx={{color:"#000"}} />
                    </IconButton>
                }
            </div>
        </Grid>
    )
}